import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { getDimensionFullName, polarColors } from '../constants';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';

const VocationOnePreferencesClarityPage = ({ user, background, number }) => {
  const { TOP_DIM_1, TOP_DIM_2, TOP_DIM_3, TOP_DIM_4, consistency } = user;
  // console.log({ TOP_DIM_1, TOP_DIM_2 });
  // console.log({ consistency });
  const firstDimName = getDimensionFullName(TOP_DIM_1);
  const secondDimName = getDimensionFullName(TOP_DIM_2);
  const thirdDimName = getDimensionFullName(TOP_DIM_3);
  const forthDimName = getDimensionFullName(TOP_DIM_4);
  // const firstDimConsistency = parseFloat(user[`CONS_${TOP_DIM_1}`]).toFixed(0);
  // const secondDimConsistency = parseFloat(user[`CONS_${TOP_DIM_2}`]).toFixed(0);
  // const thirdDimConsistency = parseFloat(user[`CONS_${TOP_DIM_3}`]).toFixed(0);
  // const forthDimConsistency = parseFloat(user[`CONS_${TOP_DIM_4}`]).toFixed(0);
  const firstDimConsistency = consistency.dimensions
    .find(k => k.key === TOP_DIM_1)
    ?.consistency.toFixed(0);
  const secondDimConsistency = consistency.dimensions
    .find(k => k.key === TOP_DIM_2)
    ?.consistency.toFixed(0);
  const thirdDimConsistency = consistency.dimensions
    .find(k => k.key === TOP_DIM_3)
    ?.consistency.toFixed(0);
  const forthDimConsistency = consistency.dimensions
    .find(k => k.key === TOP_DIM_4)
    ?.consistency.toFixed(0);
  // const globalConsistency = consistency?.global.toFixed(0);
  // console.log({ TOP_DIM_1, TOP_DIM_2, TOP_DIM_3, TOP_DIM_4 });
  // console.log({ thirdDimName, forthDimName });
  // console.log({ thirdDimConsistency, forthDimConsistency });
  // console.log(user);

  const getColor = value => {
    if (value < 40) {
      return polarColors[0];
    }
    if (value < 60) {
      return polarColors[1];
    }
    if (value < 80) {
      return polarColors[2];
    }
    if (value < 90) {
      return polarColors[3];
    }
    return polarColors[4];
  };

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>2.3. Claridad preferencias</h2>
          <p className='justified'>
            El puntaje de claridad de tus preferencias te indica{' '}
            <strong>cuán consistentes son tus intereses</strong>, es decir, da
            cuenta de la medida en que las respuestas que diste durante el test
            fueron consistentes entre sí. Si al responder el test elegiste
            reiteradamente actividades relacionadas a una misma área, entonces
            tienes un interés más marcado por esta área de preferencia. Esto es,
            tienes más claro cuáles son las actividades que más te gustaría
            realizar en tu futuro laboral.
          </p>
          <p className='justified'>
            El máximo puntaje en claridad es 100 y el mínimo es 0.{' '}
            <strong>
              Valores sobre 80 sugieren que tienes mayor consistencia en tus
              áreas de preferencia
            </strong>
            , por lo que podrías identificar carreras de interés bien definidas.{' '}
            <strong>
              Valores bajo 60 indican que tienes mayor variedad de intereses
            </strong>
            , o menor claridad sobre las cosas que más te gustaría hacer en un
            futuro, por lo que podría ser más difícil identificar una única
            carrera que te permita desarrollar todos tus intereses.
          </p>
          {/* <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details'>
                <div className='progress-name'>Consistencia Global</div>
                <ProgressBox
                  progress={globalConsistency}
                  backColor={() => getColor(globalConsistency)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{globalConsistency}</ProgressStat>
              </div>
            </div>
          </div> */}
          <div className='progress-info-group' style={{ marginTop: 24 }}>
            <div className='progress-info'>
              <div className='progress-details'>
                <div className='progress-name'>{firstDimName}</div>
                <ProgressBox
                  progress={firstDimConsistency}
                  backColor={() => getColor(firstDimConsistency)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{firstDimConsistency}</ProgressStat>
              </div>
            </div>
            <div className='progress-info'>
              <div className='progress-details'>
                <div className='progress-name'>{secondDimName}</div>
                <ProgressBox
                  progress={secondDimConsistency}
                  backColor={() => getColor(secondDimConsistency)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{secondDimConsistency}</ProgressStat>
              </div>
            </div>
          </div>

          {(TOP_DIM_3 || TOP_DIM_4) && (
            <div className='progress-info-group'>
              {TOP_DIM_3 && (
                <div className='progress-info'>
                  <div className='progress-details'>
                    <div className='progress-name'>{thirdDimName}</div>
                    <ProgressBox
                      progress={thirdDimConsistency}
                      backColor={() => getColor(thirdDimConsistency)}
                    >
                      <div className='progress'></div>
                    </ProgressBox>
                    <ProgressStat>{thirdDimConsistency}</ProgressStat>
                  </div>
                </div>
              )}

              {TOP_DIM_4 && (
                <div className='progress-info'>
                  <div className='progress-details'>
                    <div className='progress-name'>{forthDimName}</div>
                    <ProgressBox
                      progress={forthDimConsistency}
                      backColor={() => getColor(forthDimConsistency)}
                    >
                      <div className='progress'></div>
                    </ProgressBox>
                    <ProgressStat>{forthDimConsistency}</ProgressStat>
                  </div>
                </div>
              )}
            </div>
          )}

          <br />
          <br />
          <br />

          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: -45, left: -25 }}>
              <img
                src={icono}
                alt='icono binoculares'
                style={{ width: 100, height: 'auto' }}
              />
            </div>
            <div className='edu-bubble-group bg-edu-red'>
              <p className='justified'>
                Piensa en estos resultados como una guía que te muestra en qué
                etapa estás del proceso de toma de decisiones. Si obtuviste un
                puntaje bajo en claridad, no te preocupes:{' '}
                <strong>
                  es algo muy común y simplemente indica que necesitas detenerte
                  un momento a reflexionar un poco más sobre lo que te gustaría
                  o no hacer en el futuro
                </strong>
                . Para ayudarte en ese proceso, te sugerimos conversar con tu
                orientador/a, algún/a docente o tus padres, y buscar más
                información sobre aquellas carreras o trabajos que se relacionan
                con las preferencias en las que tu claridad fue más baja.
                Averigua, por ejemplo, qué tipo de tareas se realizan, cómo es
                un día de trabajo o cuáles son los principales desafíos.{' '}
                <strong>
                  Cuanto más información tengas, más fácil será identificar qué
                  aspectos de un trabajo te interesan realmente, y cuáles no
                  tanto.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOnePreferencesClarityPage;
